import Swiper from 'swiper';
import { Pagination, Navigation, A11y } from 'swiper/modules';
import ColorSelection from '../components/ColorSelection';
import ConvertHeight from '../components/ConvertHeight';
import ADA from '../components/ADA';

export default class ModRelatedTrimsAndModels {
  constructor(el) {
    this.$el = $(el);
    this.classes = {
      swiper: 'swiper',
      swiperContainer: 'swiper-container',
      swiperPagination: 'swiper-pagination',
      swiperButtonNext: 'swiper-button-next',
      swiperButtonPrev: 'swiper-button-prev',
      swiperButton: 'swiper-button',
      transitionDelay: 'delay-ins-6',
      colorOption: 'color-option',
      mouse: 'mouse',
      modelItemSelector: 'js-model-item',
      hidden: 'hidden',
    };

    this.dom = {
      $models: this.$el.find('.js-model-item'),
      $jsModelColorsWrap: this.$el.find('.js-model-colors-wrap'),
    };

    this.adaInstance = new ADA();

    this.init();
  }

  init() {
    this.changeColorModelEvent();
    this.addSwiper();
    this.addListeners();
    this.convertHeight();
  }

  addListeners() {
    $(`.${this.classes.colorOption}`).on('mouseenter', (event) => {
      this.eventHoverAddClassMouse(event);
    });
  }

  eventHoverAddClassMouse(event) {
    if (!$(event.currentTarget).hasClass(this.classes.mouse)) {
      $(event.currentTarget).addClass(this.classes.mouse);
    }
  }

  addSwiper() {
    new Swiper(this.$el.find(`.${this.classes.swiperContainer}`)[0], {
      modules: [Pagination, Navigation, A11y],
      slidesPerView: 'auto',
      speed: 500,
      pagination: {
        el: this.$el.find(`.${this.classes.swiperPagination}`)[0],
        type: 'progressbar',
      },
      navigation: {
        nextEl: this.$el.find(`.${this.classes.swiperButtonNext}`)[0],
        prevEl: this.$el.find(`.${this.classes.swiperButtonPrev}`)[0],
      },
      breakpoints: {
        // when window width is >= 700px
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
      on: {
        init: () => {
          this.$el.find(`.${this.classes.swiperButtonPrev}`).removeClass('opacity-0');
          this.handleStyleSwiperButtonDisabled();
        },
        slideChange: () => {
          const $swiperButtonElement = this.$el.find(`.${this.classes.swiperButton}`);
          $swiperButtonElement.removeAttr('style');
          this.handleStyleSwiperButtonDisabled();

          if ($swiperButtonElement.hasClass(this.classes.transitionDelay)) {
            $swiperButtonElement.removeClass(this.classes.transitionDelay);
          }
        },
        transitionEnd: () => {
          this.adaInstance.removeAttrAriaDisabled(this.$el);
        },
      },
    });

    this.adaInstance.removeAttrAriaDisabled(this.$el);
  }

  handleStyleSwiperButtonDisabled() {
    this.$el.find('.swiper-button-disabled').css({
      'opacity': '0',
      'pointer-events': 'none',
    });
  }

  changeColorModelEvent() {
    this.dom.$jsModelColorsWrap.each((_i, el) => {
      const colorSelection = new ColorSelection(el);
      const $model = $(el).closest(`.${this.classes.modelItemSelector}`);
      const $radios = $model.find('.js-color-radio');
      const $modelThumb = $model.find('.js-model-thumb');
      colorSelection.changeColorEvent(($radio) => {
        const idx = $radios.index($radio);
        $modelThumb.addClass(this.classes.hidden);
        $modelThumb.eq(idx).removeClass(this.classes.hidden);
      });
    });
  }

  updateShowHideThumbnail($wrap, idx) {
    const $modelThumb = $wrap.find('.js-model-thumb');
    $modelThumb.addClass(this.classes.hidden);
    $modelThumb.eq(idx).removeClass(this.classes.hidden);
  }

  convertHeight() {
    const convertHeight = new ConvertHeight(this.dom.$models);
    convertHeight.initialize();
  }
}
